module.exports = __webpack_public_path__ + "img/about/80243-018-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-018-2.jpg
// module id = 45
// module chunks = 0